/* eslint-disable max-lines */
/* eslint-disable no-magic-numbers */
/* eslint-disable object-curly-newline */
// TODO: remove eslint
import { ApiService } from "@/services/Api";
import moment from "moment";
import Utils from "@/utils";
import { GuestCountService } from "@/services/guestCountApi";
import { i18n } from "@/main";


const initialState = () => ({
	user: {
		firstName: "",
		lastName: "",
		role: ""
	},
	properties: [],
	activeProperty: null,
	activeOutlet: null,
	selectedDevicesFilter: [],
	weightUnits: [ "kg", "gr" ],
	weightFactors: [ 1.0, 1.0 ],
});

export default {
	namespaced: true,

	state: initialState(),
	mutations: {
		setUser,

		// setting properties has side effects, use the getMe action
		_setProperties,
		// setting active property has side effects, use the selectProperty action
		_setActiveProperty,
		// setting active outlet has side effects, use the selectOutlet action
		_setActiveOutlet,
		setSelectedDevices,
		toggleSelectedDevice,

		// closing dates
		_setClosedDays,
		_setExceptionalClosedDays,

		_setWeightUnits,

		resetState
	},
	actions: {
		getMe,
		selectProperty,
		selectOutlet,

		addClosingDate,
		editClosingDate,
		deleteClosedDay,
		addExceptionalClosedDay,
		editExceptionalClosedDay,
		deleteExceptionalClosedDay,

		setWeightUnits,
	},
	getters: {
		userInitials: state => {
			const FIRST_CHAR = 0;

			return (state.user.firstName ? state.user.firstName.charAt(FIRST_CHAR) : "") + (state.user.lastName ? state.user.lastName.charAt(FIRST_CHAR) : "");
		},
		user: state => state.user,

		properties: state => state.properties,
		activeProperty: state => state.activeProperty,

		activeOutlet: state => state.activeOutlet,

		deployments: (state, getters) => getters.activeOutlet.deployments,
		selectedDevicesFilter: state => state.selectedDevicesFilter,

		/*
		 * the dates are always sorted
		 * newer closing dates are at the beginning, older are at the end
		 */
		openClosedDays: state => state.activeOutlet.open_closed_days
			.sort((dateA, dateB) => {
				return moment(dateB.start_date) - moment(dateA.start_date);
			}),
		exceptionalClosedDays: state => state.activeOutlet.exceptional_closed_days
			.sort((dateA, dateB) => {
				return moment(dateB.start_date) - moment(dateA.start_date);
			}),

		serviceTimeSets: state => state.activeOutlet.service_time_sets,

		weightUnit: state => state.weightUnits[0],
		weightUnitMinor: state => state.weightUnits[1],
		weightFactor: state => state.weightFactors[0],
		weightFactorMinor: state => state.weightFactors[1],

		mealWeightGr: state => state.activeOutlet?.meal_weight_gr || 450,
		CO2EqPerKg: state => state.activeOutlet?.co2_eq_per_kg || 4.7,
	}
};

function resetState(state) {
	Object.assign(state, initialState());
}

function setUser(state, user) {
	state.user = {
		...state.user,
		...user
	};
}

function _setProperties(state, properties) {
	state.properties = properties;
}

function _setActiveProperty(state, property) {
	state.activeProperty = property;
}

function _setActiveOutlet(state, outlet) {
	state.activeOutlet = outlet;
}

function _setWeightUnits(state, unit) {
	state.weightUnits = unit === "kg" ? [ "kg", "gr" ] : [ "lb", "oz" ];
	state.weightFactors = unit === "kg" ? [ 1.0, 1.0 ] : [ 2.20462, 0.035274 ];
}

// `unit` is either "kg" or "lb"
function setWeightUnits({ commit }, unit) {
	commit("_setWeightUnits", unit);
}

// eslint-disable-next-line complexity
function _updateOverlappingDates(openClosedDays, startDateMoment) {

	/*
	 * If overlapping, update end_date of the first entry
	 * (in chronological order) to be the day before startDate
	 */

	for (let index = 0; index < openClosedDays.length; index++) {
		if (moment(openClosedDays[index].start_date) < startDateMoment &&
			(moment(openClosedDays[index].end_date) > startDateMoment ||
			!openClosedDays[index].end_date))
			openClosedDays[index].end_date = startDateMoment.subtract(1, "day").format("YYYY-MM-DD");

	}
	return openClosedDays;
}

function setSelectedDevices(state, deployments) {
	const selectedDevices = [...new Set(deployments.map(deployment => {
		return deployment.deployment_device_ids;
	}).flat())];
	state.selectedDevicesFilter = selectedDevices;
}

function toggleSelectedDevice(state, deployment) {
	if (!deployment.deployment_device_ids.some(deviceId => {
		return state.selectedDevicesFilter.includes(deviceId);
	})) {
		// Deployment checkbox was unchecked => Add its devices to the list of selected devices
		state.selectedDevicesFilter = [ ...state.selectedDevicesFilter,
			deployment.deployment_device_ids ].flat();
	}
	else if (state.selectedDevicesFilter.length !== 1) {
		// Deployment checkbox was checked => Remove its devices to the list of selected devices
		state.selectedDevicesFilter = state.selectedDevicesFilter.filter(deviceId => {
			return !deployment.deployment_device_ids.includes(deviceId);
		});
	}
}

// eslint-disable-next-line complexity
async function getMe({ state, commit, dispatch }) {
	if (state.activeProperty) {
		dispatch("branding/setBranding", state.activeProperty.branding_name, {root: true});
		document.body.style.visibility = "visible";
	}

	try {
		const { data } = await ApiService.getMe();

		commit("setUser", {
			firstName: data.user_info.first_name,
			lastName: data.user_info.last_name,
			role: data.user_info.role
		});

		if (!data.properties.length)
			throw new Error("no_properties_assigned");

		commit("_setProperties", data.properties);
		if (state.activeProperty) {
			// invalidate old `activeProperty` caused by vuex-persist when refreshing the page
			const activeProperty = data.properties
				.find(property => property.property_id === state.activeProperty.property_id);
			commit("_setActiveProperty", activeProperty);

			// set branding to the property's branding
			dispatch("branding/setBranding", activeProperty.branding_name, {root: true});
		}
		else
			dispatch("selectProperty", data.properties[0]);


		document.body.style.visibility = "visible";

		if (state.activeOutlet) {
			// invalidate old `activeOutlet` caused by vuex-persist when refreshing the page
			const activeOutlet = state.activeProperty.outlets
				.find(outlet => outlet.outlet_id === state.activeOutlet.outlet_id);

			commit("_setActiveOutlet", activeOutlet);
		}
	}
	catch {
		document.body.style.visibility = "visible";
	}
}

/**
 * This function is called when selecting a property from the sidebar.
 * each time we select a property, we need also to change the active outlet
 */
async function selectProperty({ commit, dispatch }, property) {
	commit("_setActiveProperty", property);
	dispatch("branding/setBranding", property.branding_name, {root: true});
	dispatch("selectOutlet", property.outlets[0]);
}

/**
 * This function is called when selecting a outlet from the sidebar.
 * each time we select a outlet, we need also to change the device
 */
function selectOutlet({ commit, getters }, outlet) {

	/*
	 * add unique key which is used later in v-for,
	 * note that the key needs to removed before we send it to the beckend.
	 */
	outlet.open_closed_days = outlet.open_closed_days.map(Utils.addUniqueKey);
	outlet.exceptional_closed_days = outlet.exceptional_closed_days.map(Utils.addUniqueKey);

	commit("_setActiveOutlet", outlet);
	commit("setSelectedDevices", getters.deployments);

	/*
	 *	reset the filters/activeDate when changing the outlet
	 *	to the last complete month where DV has been done
	 */
	const activeDate = moment(outlet.outlet_data_validity),
		outletStartDate = moment(outlet.outlet_start_date),
		weightUnit = outlet?.weight_unit || "kg";	// eslint-disable-line camelcase

	/*
	 *  if the DV date (activeDate) and the measurement date has the same month,
	 *  OR the DV date is the last day of the month,
	 *  let the active date be the DV date
	 */
	if (!activeDate.isSame(outletStartDate, "month") && !activeDate.isSame(activeDate.clone().endOf("month"), "day")) {

		/*
		 *  if active_date is NOT the same as the measurement start date,
		 *  and NOT the last day of a month,
		 *  set it to the previous month
		 */
		activeDate.subtract(1, "months");
	}
	activeDate.startOf("month");
	commit("filters/setActiveDate", activeDate, {
		root: true
	});

	commit("_setWeightUnits", weightUnit);
}

async function addClosingDate({ commit, getters }, { startDate, days }) {
	// If closing dates in the future, set end_date
	const startDateMoment = moment(startDate),
		futureClosingDate = getters.openClosedDays.reduce((filtered, closedDay) => {
			if (startDateMoment < moment(closedDay.start_date))
				filtered.push(moment(closedDay.start_date));

			return filtered;
		}, []),
		endDate = futureClosingDate.length ? moment.min(futureClosingDate).subtract(1, "day")
			.format("YYYY-MM-DD") : null,
		newDate = {
			start_date: startDate,
			end_date: endDate,
			days: [...days]
		},
		openClosedDays = _updateOverlappingDates(getters.openClosedDays, startDateMoment),
		// objects inside newClosedDats will have a __key on them
		newClosedDays = [ newDate, ...openClosedDays ];

	/*
	 * you can use the __key to find it easily in an array,
	 * or for the :key in v-for
	 */
	Utils.addUniqueKey(newDate);

	await GuestCountService.setOpenClosedDays({
		outletId: getters.activeOutlet.outlet_id,
		openClosedDays: newClosedDays.map(Utils.removeUniqueKey)
	});
	commit("_setClosedDays", newClosedDays);
}

async function editClosingDate({ commit, getters }, outlet) {
	let openClosedDays = getters.openClosedDays.filter(
			closedDay => closedDay.__key !== outlet.__key
		),
		newClosedDays = [];
	const modifiedDays = getters.openClosedDays.filter(
			closedDay => closedDay.__key === outlet.__key
		),
		startDateMoment = moment(outlet.startDate),
		futureClosingDate = openClosedDays.reduce((filtered, closedDay) => {
			if (startDateMoment < moment(closedDay.start_date))
				filtered.push(moment(closedDay.start_date));

			return filtered;
		}, []),
		endDate = futureClosingDate.length ? moment.min(futureClosingDate).subtract(1, "day")
			.format("YYYY-MM-DD") : null,
		newDate = {
			start_date: outlet.startDate,
			end_date: endDate,
			days: [...outlet.days]
		};

	if (startDateMoment.format("YYYY-MM-DD") !== moment(modifiedDays[0].start_date).format("YYYY-MM-DD"))
		openClosedDays = _updateOverlappingDates(openClosedDays, startDateMoment);


	newClosedDays = [ newDate, ...openClosedDays ];
	Utils.addUniqueKey(newDate);

	await GuestCountService.setOpenClosedDays({
		outletId: getters.activeOutlet.outlet_id,
		openClosedDays: newClosedDays.map(Utils.removeUniqueKey)
	});
	commit("_setClosedDays", newClosedDays);
}

async function deleteClosedDay({commit, getters}, deleteDate) {
	const newClosedDays = getters.openClosedDays
		.filter(closedDay => closedDay.__key !== deleteDate.__key).map(date => {
			return {
				start_date: moment(date.start_date).format("YYYY-MM-DD"),
				end_date: date.end_date ? moment(date.end_date).format("YYYY-MM-DD") : null,
				days: date.days
			};
		});

	await GuestCountService.setOpenClosedDays({
		outletId: getters.activeOutlet.outlet_id,
		openClosedDays: newClosedDays
	});
	commit("_setClosedDays", [...newClosedDays].map(Utils.addUniqueKey));
}

function _setClosedDays(state, closedDays) {
	state.activeOutlet.open_closed_days = [...closedDays];
}


async function addExceptionalClosedDay({ commit, getters }, date) {
	const dateExist = getters.exceptionalClosedDays.find(closedDay => {
			const sameStart = moment(closedDay.start_date).isSame(date.start_date, "day"),
				sameEnd = moment(closedDay.end_date).isSame(date.end_date, "day");

			return sameStart && sameEnd;
		}),
		newDate = {
			...date
		},
		newExceptionalClosedDays = [ newDate, ...getters.exceptionalClosedDays ].map(date => {
			return {
				start_date: moment(date.start_date).format("YYYY-MM-DD"),
				end_date: moment(date.end_date).format("YYYY-MM-DD")
			};
		});

	if (dateExist)
		throw new Error(i18n.t("guest_count.date_already_exist"));


	/*
	 * you can use the __key to find it easily in an array,
	 * or for the :key in v-for
	 */
	await GuestCountService.setExceptionalClosedDays({
		outletId: getters.activeOutlet.outlet_id,
		exceptionalClosedDays: newExceptionalClosedDays
	});

	commit("_setExceptionalClosedDays", newExceptionalClosedDays.map(Utils.addUniqueKey));
}

function _setExceptionalClosedDays(state, exceptionalClosedDays) {
	state.activeOutlet.exceptional_closed_days = [...exceptionalClosedDays];
}

async function editExceptionalClosedDay({ commit, getters }, editedDate) {
	// remove the previous date that was edited
	const exceptionalClosedDays = getters.exceptionalClosedDays
			.filter(closedDay => closedDay.__key !== editedDate.__key),
		dateExist = exceptionalClosedDays.find(closedDay => {
			const sameStart = moment(closedDay.start_date).isSame(editedDate.start_date, "day"),
				sameEnd = moment(closedDay.end_date).isSame(editedDate.end_date, "day");

			return sameStart && sameEnd;
		}),
		newDate = {
			...editedDate
		},
		newExceptionalClosedDays = [ newDate, ...exceptionalClosedDays ].map(date => {
			return {
				start_date: moment(date.start_date).format("YYYY-MM-DD"),
				end_date: moment(date.end_date).format("YYYY-MM-DD")
			};
		});

	if (dateExist)
		throw new Error(i18n.t("guest_count.date_already_exist"));


	await GuestCountService.setExceptionalClosedDays({
		outletId: getters.activeOutlet.outlet_id,
		exceptionalClosedDays: newExceptionalClosedDays
	});

	commit("_setExceptionalClosedDays", newExceptionalClosedDays.map(Utils.addUniqueKey));
}

async function deleteExceptionalClosedDay({ commit, getters }, deleteDate) {
	// remove the previous date  that was edited
	const newExceptionalClosedDays = getters.exceptionalClosedDays
		.filter(closedDay => closedDay.__key !== deleteDate.__key).map(date => {
			return {
				start_date: moment(date.start_date).format("YYYY-MM-DD"),
				end_date: moment(date.end_date).format("YYYY-MM-DD")
			};
		});

	await GuestCountService.setExceptionalClosedDays({
		outletId: getters.activeOutlet.outlet_id,
		exceptionalClosedDays: newExceptionalClosedDays
	});
	commit("_setExceptionalClosedDays", [...newExceptionalClosedDays].map(Utils.addUniqueKey));
}
